import { useSelector } from "react-redux"
import { selectAccountSettingMode, selectCreateAccountState, selectIsCategoryModalShow, selectIsTypingState, selectSearchTypeState, selectSearchValueState, selectSelectedCategory, selectSelectedCategoryUpdateId, selectSelectedTabs, selectTypeOfModal, selectUpdateAccountId, selectUpdateActionType, selectUpdatePassword } from "../../features/it-user-forms/user-forms-slice"

export const useUserManagementDataState = () => {

    // USER FORMS
    const createAccountForms = useSelector(selectCreateAccountState)
    const firstName = createAccountForms.firstname
    const middleName = createAccountForms.middlename
    const lastName = createAccountForms.lastname
    const suffix = createAccountForms.suffix
    const suffixId = createAccountForms.suffix.id
    const suffixName = createAccountForms.suffix.name
    const email = createAccountForms.email
    const agentCode = createAccountForms.agent_code
    const position = createAccountForms.position
    const role = createAccountForms.role
    const roleId = createAccountForms.role.id
    const roleName = createAccountForms.role.name
    const location = createAccountForms.location
    const locationId = createAccountForms.location?.id
    const locationName = createAccountForms.location?.name
    const department = createAccountForms.department
    const departmentId = createAccountForms.department?.id
    const departmentName = createAccountForms.department?.name
    const phoneNumber = createAccountForms.phoneNumber
    const reportingTo = createAccountForms.reporting_to_id
    const reportingToId = createAccountForms.reporting_to_id?.id
    const reportingToName = createAccountForms.reporting_to_id?.name

    // UPDATE ACCOUNT
    const updateActionType = useSelector(selectUpdateActionType)
    const isViewActionType = updateActionType === 'view'
    const isUpdateActionType = updateActionType === 'update'

    const updateAccountId = useSelector(selectUpdateAccountId)

    // ACCOUNT SETTINGS
    const accountSettingMode = useSelector(selectAccountSettingMode)
    const isViewAccountSetting = accountSettingMode === 'view'
    const isUpdateProfileAccountSetting = accountSettingMode === 'updateProfile'
    const isUpdatePasswordAccountSetting = accountSettingMode === 'updatePassword'

    // UPDATE PASSWORD
    const updatePassword = useSelector(selectUpdatePassword)
    const valuesPassword = updatePassword.values.password
    const valuesNewPassword = updatePassword.values.newPassword
    const valuesConfirmPassword = updatePassword.values.confirmPassword
    const isVisiblePassword = updatePassword.values.password
    const isVisibleNewPassword = updatePassword.values.newPassword
    const isVisibleConfirmPassword = updatePassword.values.confirmPassword

    // SEARCH
    const searchType = useSelector(selectSearchTypeState)
    const searchValue = useSelector(selectSearchValueState)
    const isTyping = useSelector(selectIsTypingState)

    // CATEGORY
    const categoryTabs = useSelector(selectSelectedTabs)
    const isDepartmentCategory = categoryTabs === 'departments'
    const isLocationCategory = categoryTabs === 'locations'
    const isRolesCategory = categoryTabs === 'roles'

    const categoryId = useSelector(selectSelectedCategoryUpdateId)
    const categoryModalType = useSelector(selectTypeOfModal)
    const isNewCategory = categoryModalType === 'new'
    const isUpdateCategory = categoryModalType === 'update'
    const isShowCategory = useSelector(selectIsCategoryModalShow)

    const selectedCategory = useSelector(selectSelectedCategory)
    const selectedCategoryName = selectedCategory.name
    const selectedCategoryCode = selectedCategory.code
    const selectedCategoryIsActive = selectedCategory.is_active

    return {
        // USER FORMS
        createAccountForms,
        firstName,
        middleName,
        lastName,
        suffix,
        suffixId,
        suffixName,
        email,
        agentCode,
        position,
        role,
        roleId,
        roleName,
        location,
        locationId,
        locationName,
        department,
        departmentId,
        departmentName,
        phoneNumber,
        reportingTo,
        reportingToId,
        reportingToName,

        // UPDATE ACCOUNT
        updateActionType,
        isViewActionType,
        isUpdateActionType,
        updateAccountId,

        // ACCOUNT SETTINGS
        accountSettingMode,
        isViewAccountSetting,
        isUpdateProfileAccountSetting,
        isUpdatePasswordAccountSetting,

        // UPDATE PASSWORD
        updatePassword,
        valuesPassword,
        valuesNewPassword,
        valuesConfirmPassword,
        isVisiblePassword,
        isVisibleNewPassword,
        isVisibleConfirmPassword,

        // SEARCH
        searchType,
        searchValue,
        isTyping,

        // CATEGORY
        categoryTabs,
        isDepartmentCategory,
        isLocationCategory,
        isRolesCategory,
        categoryId,
        categoryModalType,
        isNewCategory,
        isUpdateCategory,
        isShowCategory,
        selectedCategory,
        selectedCategoryName,
        selectedCategoryCode,
        selectedCategoryIsActive,
    }
}